export const carrotApiHost = process.env.REACT_APP_CARROT_API_HOST
export const gyeongjuroShopUrl = 'https://gjsmarttour.kr'
export const gyeongjuroShopBaseUrl = `${gyeongjuroShopUrl}/shop/ins.nm?menuCd=41&shopId=`
